import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface BoardActivityDto {
  date: string;
  boardType: string;
  address: string;
  activityType: string;
  status: string;
  notes?: string;
  adminNotes?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  constructor(private readonly http: HttpClient) {}

  fetchBoardActivity(month: number, year: number) {
    return this.http.get<BoardActivityDto[]>(
      `${environment.backendUrl}/v0/agent/me/board-activity`,
      {
        params: {
          month: month.toString(),
          year: year.toString(),
        },
      }
    );
  }
}
